<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Funds on Account</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body d-flex flex-column align-items-center">
  
  <div class="align-self-end mb-3">
    <button type="button" 
            class="btn btn-success" 
            (click)="addFund()">
      <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
      Add Fund
    </button>
  </div>

  <div class="border rounded bg-white mb-3 w-100" style="height: 350px; overflow-y: auto;">
    <div class="d-flex align-items-center p-2 border-bottom" 
         *ngFor="let fund of caseFunds; last as isLast"
         [class.border-bottom-0]="isLast">
      <div class="flex-grow-1">{{fund.description}}</div>
      <div class="text-end fw-semibold" style="width: 100px;">{{fund.net | currency:'£'}}</div>
      <button type="button" 
              class="btn btn-link btn-sm p-0 text-danger ms-2" 
              (click)="removeFund(fund.id)">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
  </div>

  <div class="border rounded bg-white d-flex align-items-center p-2 fw-bold w-100" style=" height: 40px;">
    <div class="flex-grow-1">Total:</div>
    <div class="text-end" style="width: 100px;">{{caseFundsTotal | currency:'£'}}</div>
  </div>

</div>